import { render, staticRenderFns } from "./Payment-Create.vue?vue&type=template&id=6201ec1a"
import script from "./Payment-Create.vue?vue&type=script&lang=js"
export * from "./Payment-Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports